import { render, staticRenderFns } from "./SelfBirthCert.vue?vue&type=template&id=4a1190a7&"
import script from "./SelfBirthCert.vue?vue&type=script&lang=js&"
export * from "./SelfBirthCert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports